import Text from "./text";

export default class MultiLineText extends Text {
    
}